import type {PublicMethodUtils} from '@wix/document-services-types'
import type {DeprecatedOldBadPerformancePublicAPI} from '@wix/document-services-public-types'
import {componentDetectorAPI, component, layouters, mobileActions} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (
    publicMethodUtils: PublicMethodUtils
): PublicModuleDeclaration<DeprecatedOldBadPerformancePublicAPI> {
    return {
        methods: {
            deprecatedOldBadPerformanceApis: {
                components: {
                    getAllComponents: publicMethodUtils.defineGetter(componentDetectorAPI.getAllComponents),
                    getAllComponentsFromFull: publicMethodUtils.defineGetter(
                        componentDetectorAPI.getAllComponentsFromFull
                    ),
                    getChildren: publicMethodUtils.defineGetter(component.getChildrenWithScopes),
                    getChildrenFromFull: publicMethodUtils.defineGetter(component.getChildrenFromFull),
                    getContainer: publicMethodUtils.defineGetter(component.getContainer),
                    getAncestors: publicMethodUtils.defineGetter(component.getAncestors),
                    getRepeatedComponents: publicMethodUtils.defineGetter(component.getRepeatedComponents),
                    isDescendantOfComp: publicMethodUtils.defineGetter(componentDetectorAPI.isDescendantOfComp),
                    get: {
                        byXYRelativeToStructure: publicMethodUtils.defineGetter(
                            componentDetectorAPI.getComponentsAtXYRelativeToStructure
                        ),
                        byXYRelativeToScreen: publicMethodUtils.defineGetter(
                            componentDetectorAPI.getComponentsAtXYRelativeToScreen
                        ),
                        getComponentsAtXYConsideringFrame: publicMethodUtils.defineGetter(
                            componentDetectorAPI.getComponentsAtXYConsideringFrame
                        ),
                        byType: publicMethodUtils.defineGetter(componentDetectorAPI.getComponentByType),
                        byAncestor: publicMethodUtils.defineGetter(componentDetectorAPI.getComponentsUnderAncestor)
                    },
                    modes: {
                        getFirstAncestorWithActiveModes: publicMethodUtils.defineGetter(
                            component.modes.getFirstAncestorWithActiveModes
                        )
                    }
                },
                layouters: {
                    getParentCompWithOverflowHidden: publicMethodUtils.defineGetter(
                        layouters.getParentCompWithOverflowHidden
                    )
                },
                mobile: {
                    hiddenComponents: {
                        get: publicMethodUtils.defineGetter(mobileActions.hiddenComponents.getFiltered)
                    }
                }
            }
        }
    }
}
